import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfferService {
  apiUrl = environment.apiUrlPsV1;

  constructor(
    private api: ApiService,
    private authService: AuthService,
    private http: HttpClient,
  ) { }

  getCategories(params) {
		return this.http.get(environment.apiUrlPsV1 + "/categories?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
  searchMerchants(params) {
		return this.http.get(environment.apiUrlPsV1 + "/merchants?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
  getMerchants(params) {
    // search by name
    let elgble = this.authService.isAuthenticated() ? true : false;
    return this.api
      .get(this.apiUrl + 'merchants' + (elgble ? '?elgble=true' : ''), { params: params });
  }

  getOffersByMerchant(merchantId) {
    let elgble = this.authService.isAuthenticated() ? true : false;
    let params = {};
    return this.api
      .get(this.apiUrl + 'offers?merchant_id=' + merchantId + (elgble ? '&elgble=true' : ''), { params: params })
      .toPromise();
  }

  getOffers() {
    let elgble = this.authService.isAuthenticated() ? true : false;
    let params = {};
    return this.api
      .get(this.apiUrl + 'offers' + (elgble ? '?elgble=true' : ''), { params: params })
      .toPromise();
  }

  getCategoryDetails(params = {}) {
    return this.http.get(environment.apiUrlPsV1 + "/category_details?elgble=true&per_page=20", {
			params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
  }

  getCategoryDetail(id, params) {
    let elgble = this.authService.isAuthenticated() ? true : false;
    return this.api.get(this.apiUrl + 'category_details/' + id + (elgble ? '?elgble=true' : ''), {
      params: params
    }).toPromise();
  }

  redeem(offer, params) {
    return this.api.post(this.apiUrl + "offers/" + offer.id + "/redeem", params).toPromise();
  }

  getRedemptions(params = {}) {
    return this.api.get(this.apiUrl + "redemptions?", { params: params });
  }

}
